import React from "react";

import { TextInput } from "../../atoms";
import { monthsOfYearModel } from "../../models";

const renderHeaders = (headers) => {
	return headers.map((header, i) => <th key={i}>{header}</th>);
};

const renderObservation = (values, changeAction, tableId, row, obs) => {
	return (
		<td>
			<TextInput 
				name={tableId}
				id={row.id+"_"+obs} 
				type="text" 
				value={values[tableId] ? values[tableId][row.id+"_"+obs] : ""} 
				changeAction={changeAction}
			/>
		</td>
	);
};

const renderRows = (values, changeAction, tableId, obs) => {
	return monthsOfYearModel.map((row, i) => 
		<tr key={i}>
			<td>{row.label}</td> 
			<td><TextInput className={"mini-input"} name={tableId} id={row.id} type={"tel"} value={values[tableId] ? values[tableId][row.id] : ""} changeAction={changeAction} /></td>
			{obs ? renderObservation(values, changeAction, tableId, row, obs) : ""}
		</tr>
	);
};

export const TableMonthsOfYear = props => {
	return (
		<div>
			<p>{props.label}</p>
			<table className="highlight centered year-table">
				<thead>
					<tr>
						{renderHeaders(props.headers)}
					</tr>
				</thead>
				<tbody>
					{renderRows(props.values, props.changeAction, props.id, props.obs)}
				</tbody>
			</table>
		</div>
	);
};


// WEBPACK FOOTER //
// src/molecules/lib/TableMonthsOfYear.js